import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";
import {  MailIcon, MapPin, PhoneIcon } from "lucide-react";


const Overview = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="flex flex-col gap-8">

        {/* Heading */}
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <Paragraph className="text-[#00764B] text-sm bg-[#FAFAFA] rounded-2xl py-1 px-4 flex items-center justify-center">Contact Us</Paragraph>
          </div>
          <Heading level={3} >{data.title ?? "Default Title"}</Heading>
        </div>
        
        {/* Body */}
        <div className="grid gap-6 lg:grid-cols-3">
          <div className="flex flex-col gap-1">
            <MailIcon color="#00764B" />
            <Heading level={4} >Email</Heading>
            <Paragraph className="">{data.emailAddress ?? "email@example.com"}</Paragraph>
          </div>
          <div className="flex flex-col gap-1">
            <PhoneIcon color="#00764B" />
            <Heading level={4} >Phone</Heading>
            <Paragraph className="">{` ${data.phoneNumber ?? "+1234567890"}`}</Paragraph>
          </div>
          <div className="flex flex-col gap-1">
            <MapPin color="#00764B" />
            <Heading level={4} >Head Quarter</Heading>
            <Paragraph className="">{data.address ?? "123 Main St, Anytown, USA"}</Paragraph>
          </div>
        </div>
        
      </div>
    </EditableSection>
  )
}

export default Overview